import apiClient from '../../../shared/api/client';

export const getEncoders = async () => {
  const response = await apiClient.get('/encoder');
  return response?.data;
};

export const getEncoderById = async (encoderId) => {
  const response = await apiClient.get(`/encoder/${encoderId}`);
  return response?.data;
};

export const createEncoder = async ({ pacienteId, userId, payload }) => {
  const response = await apiClient.post(`/encoder/${pacienteId}/${userId}`, payload);
  return response?.data;
};

export const updateEncoder = async ({ encoderId, payload }) => {
  const response = await apiClient.put(`/encoder/${encoderId}`, payload);
  return response?.data;
};

export const deleteEncoder = async (encoderId) => {
  const response = await apiClient.delete(`/encoder/${encoderId}`);
  return response?.data;
};

export const getPacienteById = async (pacienteId) => {
  const response = await apiClient.get(`/pacientes/${pacienteId}`);
  return response?.data;
};

export const importEncoderCsv = async ({ file, date }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('date', date);

  const response = await apiClient.post('/encoder/import-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response?.data;
};
